<template>
  <div class="register">
    <div class="wrapper">
      <div class="dialog dialog-shadow" style="display: block; margin-top: -362px;">
        <div class="title">
        </div>
        <div class="content">
          <ul class="common-form">
            <li>
              <div class="input">
                <input type="phone" v-model="registered.userName" placeholder="手机号码"
                  @keyup="registered.userName = registered.userName.replace(/[^\w\.\/]/ig,'')">
              </div>
            </li>
           <li>
             <div class="input-sms">
               <input type="number" v-model="registered.smsCode" :disabled="!smsFlag" placeholder="短信验证码" >
               <y-button
                  :classStyle="registered.userName.length === 11 && !smsFlag && smstxt === '获取验证码'?'main-btn':'disabled-btn'"
                  :text="smstxt" style="margin:0;width: 35%;" @btnClick="snedSmsCode">
                </y-button>
              </div>
            </li>
			<li>
			  <div class="input">
			    <input type="password" v-model="registered.userPwd" placeholder="新密码">
			  </div>
			</li>
          </ul>

          <div style="margin: 20px 0;">
          <y-button
              :classStyle="registered.userPwd&& registered.userName && registered.smsCode && registxt === '修改密码'?'main-btn':'disabled-btn'"
              :text="registxt" style="margin: 0;width: 100%;height: 48px;font-size: 18px;line-height: 48px"
              @btnClick="register">
            </y-button>
          </div>

          <div class="border" style="margin-bottom: 10px;"></div>
          <ul class="common-form pr">
            <li style="text-align: center;line-height: 48px;margin-bottom: 0;font-size: 12px;color: #999;">
              <a href="javascript:;" style="margin: 0 5px" @click="toLogin">返回登陆</a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  export default {
    data() {
      return {
        registered: {
          userName: '',
          userPwd: '',
          smsCode: '',
          errMsg: ''
        },
        registxt: '修改密码',
        smstxt: '获取验证码',
        smsFlag: false,
        dialogVisible: false,
        dialogTitle: '',
        dialogContent: ''
      }
    },
    computed: {
      count() {
        return this.$store.state.isLogin
      }
    },
    methods: {
      snedSmsCode() {
        this.$api.get({
            url: '/common/sendSMS',
            data:{
              mobile:this.registered.userName
            }
        }).then(res=>{
          if(res.code==200) {
            this.$yxz.msg('验证码发送成功','success');
            this.smsFlag = true
          }
        })
      },
      open(t, m) {
        this.$notify.info({
          title: t,
          message: m
        })
      },
      message(m) {
        this.$message.error({
          message: m
        })
      },
      register() {
        this.registxt = '正在修改密码...'
        let userName = this.registered.userName
        let userPwd = this.registered.userPwd
        let smsCode = this.registered.smsCode
        if (!userName || !userPwd ) {
          this.$yxz.msg('账号密码不能为空!')
          this.registxt = '修改密码'
          return false
        }
        if (!smsCode) {
          this.$yxz.msg('短信验证码不能为空')
          this.registxt = '修改密码'
          return false
        }
        this.$api.post({
          url:'/resetPassword',
          data: {
              loginName: userName,
              loginPassword: userPwd,
              smsCode: smsCode
          }
        }).then(res => {
          if (res.code == 200) {
             this.$yxz.msg(res.msg,'success')
             this.toLogin()
          } else {
            this.$yxz.msg(res.msg)
            this.registxt = '修改密码'
            return false
          }
        })
      },
      toLogin() {
        this.$yxz.to('/login')
      }
    },
    mounted() {
      this.$yxz.title("医小智 - 找回密码")
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  * {
    box-sizing: content-box;
  }
  .register {
    overflow-x: hidden;
    overflow-y: hidden;

    .input {
      width: 370px;
      height: 50px;
      display: flex;
      align-items: center;

      input {
        font-size: 16px;
        width: 100%;
        height: 100%;
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 6px;
      }
    }

    .input-sms {
      height: 50px;
      display: flex;
      align-items: center;

      input {
        font-size: 16px;
        width: 231px;
        height: 100%;
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 6px;
        margin-right: 10px;
      }
    }

    .wrapper {
      background: url(/static/images/bg.png) repeat;
      background-size: 100px;
      min-height: 100%;
      min-width: 100%;
    }
  }

  .register .dialog {
    width: 450px;
    border: 1px solid #dadada;
    border-radius: 8px;
    top: 50%;
    left: 50%;
    margin-left: -225px;
    position: absolute;

    .title {
      background: linear-gradient(#fff, #f5f5f5);
      height: auto;
      overflow: visible;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
      position: relative;
      background-image: url(/static/images/bg_login.png);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 225px;
      box-shadow: none;
      border-radius: 8px 8px 0px 0px;
      margin-bottom: 30px;
    }

    .content {
      padding: 0px 40px 30px;
      height: auto;

      .common-form {
        li {
          clear: both;
          margin-bottom: 15px;
          position: relative;
        }
      }
    }
  }

  .register .dialog-shadow {
    -webkit-box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
    -moz-box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
    box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
  }

  .border {
    margin-top: 10px;
    border-bottom: 1px solid #ccc;
  }

  .dialog-content {
    height: 55vh;
    overflow: auto;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// resetPassword.vue?263bad55